import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const DURUM_RENK: Record<string, string> = { 'Taslak': '#94a3b8', 'Gonderildi': '#1890ff', 'Kabul Edildi': '#52c41a', 'Reddedildi': '#ff4d4f' };

@Component({
  selector: 'teklif-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#1890ff">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('urunHizmet') || 'Isimsiz Teklif' }}</div>
        @if (deger('firma')) { <div class="sk-alt">{{ deger('firma') }}</div> }
        @if (deger('fiyat')) { <div class="sk-alt">{{ deger('fiyat') }} {{ deger('paraBirimi') || 'TL' }}</div> }
      </div>
      <div class="sk-sag">
        @if (deger('durum')) { <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ deger('durum') }}</span> }
        @if (deger('gecerlilikTarihi')) { <span class="sk-alt">{{ deger('gecerlilikTarihi') | date:'dd.MM.yyyy' }}</span> }
      </div>
    </div>
  `,
})
export class TeklifKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  durumRenk = computed(() => DURUM_RENK[this.deger('durum')] || '#94a3b8');
}
